/*
 * fn: getFilterCount
 *
 * Counts the active filters of a route
 *
 * Advanced filters count individually
 *
 */
import { getRouteConfig, getRouteParamConfig, isRouteParamType, type RouteType } from '@/defs/route'

import { getRouteTemplateSegments } from './getRouteTemplateSegments'

export const getFilterCount = (route?: RouteType) => {
  if (!route) return 0

  const { queryParams, template } = getRouteConfig(route.section)

  const params = [
    ...getRouteTemplateSegments(template).flatMap(({ type, value }) => (type === 'optional' ? [value] : [])),
    ...(queryParams || []),
  ]

  return params.reduce((total, param) => {
    if (!isRouteParamType(param) || !getRouteParamConfig(param).isFilter) return total

    const value = route[param]
    if (Array.isArray(value)) return total + value.length

    return value ? total + 1 : total
  }, 0)
}
